import { Project, AnalysisMode } from '../../types'

// 复制项目时从源项目继承（且在向导里锁定）的设置集合。
export interface CloneInheritedSettings {
  skillId: string
  scriptSkillId: string
  languageSkillId: string
  outputLanguage: string
  analysisMode: AnalysisMode
}

// 从源 Project 抽出可继承字段，缺省给安全默认值。
export function extractInheritedSettings(project: Project): CloneInheritedSettings {
  return {
    skillId: project.skillId ?? '',
    scriptSkillId: project.scriptSkillId ?? '',
    languageSkillId: project.languageSkillId ?? '',
    outputLanguage: project.outputLanguage ?? '',
    analysisMode: project.analysisMode ?? 'basic',
  }
}

// 勾了「保留剧集分镜提示词」的克隆，才锁定四个技能/语言字段。
export function shouldLockSkillsAndLanguage(isClone: boolean, keepShotPrompts: boolean): boolean {
  return isClone && keepShotPrompts
}

// 克隆提交体里和剧本改写相关、需按 keepShotPrompts 区别对待的字段。
// scriptSkillId 本身在 payload 里始终发送（keepShotPrompts 时后端忽略、恒继承源），故不在此。
export interface CloneScriptRewriteFields {
  enableScriptNormalization?: boolean
  scriptSkillValues?: Record<string, string>
}

// keepShotPrompts 时这些恒继承源项目 → 不发送（后端浅拷贝保留源值）。
// 未勾时剧本改写技能在向导里可编辑，必须把开关与变量一并发送，
// 否则会出现「scriptSkillId 被覆盖但 enableScriptNormalization 仍继承源」的半状态。
// 口径与 createProjectScriptRewrite.buildCreateScriptRewriteFields 保持一致：选了技能即开启。
export function buildCloneScriptRewriteFields(
  keepShotPrompts: boolean,
  scriptSkillId: string,
  scriptSkillValues: Record<string, string>,
): CloneScriptRewriteFields {
  if (keepShotPrompts) {
    return {}
  }
  return {
    enableScriptNormalization: !!scriptSkillId,
    scriptSkillValues: scriptSkillId ? scriptSkillValues : undefined,
  }
}

// 资产分析模式 → 现有按钮文案 i18n key（projectList 命名空间）。
export function analysisModeTitleKey(mode: AnalysisMode): string {
  switch (mode) {
    case 'external':
      return 'form.analysisExternal'
    case 'advanced':
      return 'form.analysisAdvanced'
    case 'basic':
    default:
      return 'form.analysisBasic'
  }
}
